import { useUIStore } from '@/config/stores/ui-store';
import { hubConnectionManager } from '@/core/realtime';
import { useEffect } from 'react';

/**
 * Hook to subscribe to active conversation and bubble conversations for realtime updates
 */
export const useConversationSubscription = () => {
  const { activeConversation, activeBubbleConvs } = useUIStore();

  useEffect(() => {
    const currentIds = new Set<string>();

    if (activeConversation?.conversationId) currentIds.add(activeConversation.conversationId);
    for (const conv of activeBubbleConvs) if (conv.conversationId) currentIds.add(conv.conversationId);

    for (const id of currentIds) {
      hubConnectionManager.subscribeToConversation(id);
    }
  }, [activeConversation, activeBubbleConvs.length]);
};
